import React, { Component } from 'react';
import MetaTags from 'react-meta-tags';
import DCENJ from '../../Images/BlogDI.jpg';

class BlogDI extends Component {
    constructor(props) {
        super(props);

        this.state = {
            Actual: ''

        }
    }
    componentDidUpdate() {
        if (this.state.Actual != window.location.href) {
            this.state.Actual = window.location.href;
            this.props.reportarVisita(window.location.href, 'Blog', false)
        };
    }
    render() {
        return (
            <center>
                <div style={{ margin: "40px", maxWidth: "980px", width: "auto", textAlign: "justify" }}>
                    <center style={{marginTop : "35px"} }>
                        <img height="480px" src={DCENJ} alt="discapacidad cognitiva" />
                        <h1 style={{fontSize: "18pt"}}>Aspectos Clave de la Discapacidad Intelectual</h1>
                    </center>
                    <br />
                    <p>La discapacidad intelectual (DI) es una condición que afecta a muchas personas desde la infancia y que influye en sus capacidades cognitivas, adaptativas y sociales. Conocer los aspectos clave de la DI no solo es esencial para educadores y profesionales de la salud, sino también para la sociedad en general. En este artículo te presentamos los puntos más importantes que debes tener en cuenta</p>
                    <strong>
                        <h3>¿Qué es la Discapacidad Intelectual?</h3>
                    </strong>
                    <p>La DI se caracteriza por limitaciones significativas en el funcionamiento intelectual y en las habilidades adaptativas, que afectan áreas como la comunicación, el autocuidado, la vida en el hogar y las habilidades sociales. Estas limitaciones suelen identificarse durante el desarrollo, generalmente antes de los 18 años.</p>
                    <strong>
                        <h3>La Importancia de una Evaluación Diagnóstica</h3>
                    </strong>
                    <p>Uno de los primeros pasos para apoyar a una persona con DI es realizar una evaluación diagnóstica adecuada. Esta evaluación incluye pruebas estandarizadas que no solo miden el coeficiente intelectual (CI), sino también la capacidad de la persona para adaptarse y funcionar en su entorno cotidiano. Comprender las necesidades individuales es fundamental para diseñar intervenciones efectivas.</p>
                    <strong>
                        <h3>Intervención Temprana: Un Cambio de Vida</h3>
                    </strong>
                    <p>Cuanto antes se identifiquen las limitaciones, mayores serán las posibilidades de mejorar la calidad de vida de la persona. La intervención temprana es uno de los elementos más transformadores en el desarrollo de un niño con DI. Los programas educativos y terapéuticos pueden mejorar significativamente las habilidades cognitivas, sociales y motoras, preparando a los niños para una vida más independiente y satisfactoria.</p>
                    <strong>
                        <h3>Inclusión Educativa: Un Derecho Fundamental</h3>
                    </strong>
                    <p>La educación inclusiva es otro pilar crucial. Los niños con DI tienen derecho a ser educados en aulas regulares, con las adaptaciones necesarias para garantizar su aprendizaje y participación activa. Este enfoque no solo promueve su desarrollo académico, sino que también facilita la integración social, fomentando la empatía y el respeto entre sus compañeros.</p>
                    <strong>
                        <h3>Apoyo Multidisciplinario</h3>
                    </strong>
                    <p>
                        Para que una persona con DI alcance su máximo potencial, es esencial que cuente con un equipo de apoyo multidisciplinario. Psicólogos, educadores, terapeutas ocupacionales y logopedas, entre otros, trabajan juntos para diseñar estrategias que aborden las diversas necesidades de la persona. Este enfoque integral permite una atención personalizada y más efectiva.

                    </p>
                    <strong>
                        <h3>Fomentar la Autonomía y la Autodeterminación</h3>
                    </strong>
                    <p>Un objetivo clave de cualquier intervención es fomentar la autonomía de las personas con DI. Aunque puedan necesitar apoyo en ciertas áreas, es fundamental que se les permita tomar decisiones sobre su vida, participar activamente en su comunidad y desarrollar su sentido de independencia. Este enfoque no solo mejora su calidad de vida, sino que también fortalece su autoestima y bienestar emocional.</p>
                    <strong>
                        <h3>Conclusión</h3>
                    </strong>
                    <p>La discapacidad intelectual es una condición que debe ser abordada con un enfoque integral y humano. La evaluación temprana, la inclusión educativa, el apoyo multidisciplinario y la promoción de la autonomía son algunos de los pilares fundamentales para mejorar las oportunidades y el bienestar de las personas con DI. Entender estos aspectos nos acerca a construir una sociedad más inclusiva y justa.</p>
                    <h2>Bibliografía</h2>
                    <ul>
                        <li>García Fernández, J. M., Pérez Cobacho, J. & Berruezo Adelantado, P. P. (2010). Discapacidad Intelectual: desarrollo, comunicación e intervención. Editorial CEPE.</li>
                        <li>Luque Rojas, M. J. & Luque Parra, D. J. (2016). Discapacidad intelectual: consideraciones para su intervención psicoeducativa. Wanceulen Editorial.</li>
                    </ul>
                    <br/>
                    <br/>
                    <br/>
                    <br />
                </div>
            </center>
        );
    }
}

export default BlogDI;


// WEBPACK FOOTER //
// ./src/components/Blogs/DI.js